// Pré-busca do Talk da modal. Ao abrir uma Talk existente, o Context "externo" (cenário talk) só deixa o formulário
// montar depois de receber o contexto/template; o Context "interno" (cenário form) então pedia o Talk — duas idas e
// voltas em série sem dependência de dados (o id já é conhecido). O externo dispara o GET do Talk junto com o do
// contexto e o interno consome essa mesma promessa uma única vez, em vez de repetir a requisição.
//
// A promessa é de uso único e expira em segundos: nunca serve um Talk "velho" a uma abertura posterior.
const TTL_MS = 15000
const pending = new Map()

const keyOf = (subject, id) => `${subject}/${id}`

// O formulário da modal não lê os anexos (a aba Anexos refaz a leitura), por isso includeAttachments=false.
export const talkFormUrl = (api, subject, id) => `${api}/talk/${subject}/${id}?includeAttachments=false`

export const prefetchTalk = (subject, id, request) => {
  const promise = request()
  promise.catch(() => {}) // se ninguém consumir, não vira "unhandled rejection"; quem consumir recebe o erro normalmente
  pending.set(keyOf(subject, id), { promise, at: Date.now() })
}

export const takePrefetchedTalk = (subject, id) => {
  const key = keyOf(subject, id)
  const entry = pending.get(key)
  pending.delete(key)
  return entry && Date.now() - entry.at < TTL_MS ? entry.promise : null
}
